import { useApi } from '@/api'

export const useCampaignReferencesResource = () => {
  const api = useApi()
  const campaignOf = (organizationId: string, campaignId: string) => api.api.v1.organizations({ organizationId }).campaigns({ campaignId })

  return {
    getProductPhoto: (organizationId: string, campaignId: string) => campaignOf(organizationId, campaignId)['product-photo'].get(),
    setProductPhoto: (organizationId: string, campaignId: string, file: File) =>
      campaignOf(organizationId, campaignId)['product-photo'].post({ file })
  }
}
